import { SizeOrUndefined } from "../primitives/size";
import { z } from "zod";
export const FigmaFileStructureNodeType = z.enum([
    "DOCUMENT",
    "CANVAS",
    "FRAME",
    "COMPONENT",
    "COMPONENT_SET",
]);
export const FigmaFileStructureNodeBase = z.object({
    id: z.string(),
    name: z.string(),
    type: FigmaFileStructureNodeType,
    size: SizeOrUndefined,
    parentComponentSetId: z.string().optional(),
});
export const FigmaFileStructureNode = FigmaFileStructureNodeBase.extend({
    children: z.lazy(() => FigmaFileStructureNode.array()),
});
export const FigmaFileStructureStatistics = z.object({
    frames: z
        .number()
        .nullable()
        .optional()
        .transform((v) => v !== null && v !== void 0 ? v : 0),
    components: z
        .number()
        .nullable()
        .optional()
        .transform((v) => v !== null && v !== void 0 ? v : 0),
    componentSets: z
        .number()
        .nullable()
        .optional()
        .transform((v) => v !== null && v !== void 0 ? v : 0),
});
export const FigmaFileStructureElementData = z.object({
    value: z.object({
        structure: FigmaFileStructureNode,
        assetsInFile: FigmaFileStructureStatistics,
    }),
});
export function figmaFileStructureToMap(root) {
    const map = new Map();
    recursiveFigmaFileStructureToMap(root, map);
    return map;
}
function recursiveFigmaFileStructureToMap(node, map) {
    map.set(node.id, node);
    for (const child of node.children)
        recursiveFigmaFileStructureToMap(child, map);
}
